import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "@/styles/globals.css";
import "@/styles/print.css";
import '@umd-dit/react-auth/style.css';

// Define OIDC web component
import '@umd-dit/react-auth';

// Configure workspaces component authentication
import { configureWorkspacesAuth } from '@umd-dit/workspaces-component-react';
import { addAuthHeaders } from '@umd-dit/oidc-core';

// Configure the workspaces component to use our auth headers
// Note: Individual components will set their own API URLs via the workspacesApiUrl prop
configureWorkspacesAuth(addAuthHeaders);

// Debug log to check environment variables
console.log('[DEBUG] Environment Variables:', {
  apiGatewayUrl: import.meta.env.VITE_API_URL,
  workspacesApiUrl: import.meta.env.VITE_WORKSPACES_API_URL,
  costsApiUrl: import.meta.env.VITE_COSTS_API_URL,
  jobsApiUrl: import.meta.env.VITE_JOBS_API_URL,
  oidcDevmode: import.meta.env.VITE_OIDC_DEVMODE,
  mode: import.meta.env.MODE,
  base: import.meta.env.BASE_URL
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);